import { async } from "@firebase/util";
import { useState } from "react";
import { UseAuth } from "./AuthContext/AuthContext";
import { Usedata } from "./Context/Allcontext";

function Login(){
    const {setAclogin, Aclogin , ActivLogin, ActiveSinup} = Usedata()
    const {Login, crentuser} = UseAuth()
    const [email,setemail] = useState()
    const [password,setpassword] = useState()
    if(crentuser && crentuser){
        setAclogin(false)
    }


    const Handalelogin = async(e) => {
        e.preventDefault()
        try{
            await Login(email,password)
        } catch(err){
            console.log(err)
        }
    }

    return(
        <>
        {Aclogin && (
        <section className={Aclogin ? "overley login active": "overley login"}>
        <div className="haye">
            {/* <!--login--> */}
            <div className="model_sinup login">
                <form method="post" onSubmit={Handalelogin}>
                <div className="close_oplsulet" onClick={ActivLogin}><i className="fa-solid fa-circle-xmark"></i></div>
                    <h2>Gal Akoon Hore</h2>
                    <input type="email" name="email" placeholder="Qor E-mailkaaga" 
                    onInput={(e => setemail(e.target.value))}
                    value={email}
                    />
                    <input type="password" name="password" placeholder="Qor Passwor-kaaga"
                    onInput={(e => setpassword(e.target.value))}
                    value={password}
                    />
                    <div className="count_err">
                        <p className="err"></p>
                    </div>
                    
                    <button type="submit">Diwaan Gali</button>
                    <p className="samayso" onClick={ActiveSinup}>
                        Samayso Akoon
                    </p>
                </form>
            </div>
        </div>
        </section>
        )}
        </>
    )
}


export default Login